function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M0 .163h23.507v12.81H0z"
}), React.createElement("path", {
  id: "c",
  d: "M.191.026h19.714V19.74H.191z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(8 12.137)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  d: "M3.92 7.85c2.006 2.479 4.838 4.691 8.04 5.087a6.81 6.81 0 0 0 1.171.02c.443-1.352 1.058-2.522 1.87-3.566.7-.896 1.48-1.663 2.318-2.33a8.203 8.203 0 0 0-1.005-.279c-1.367-.287-2.813-.472-4.235-.707 1.272-.013 2.66-.275 3.908-.182.777.06 1.528.235 2.255.49 1.635-1.125 3.441-1.954 5.265-2.71-2.245-2.11-6.082-3.231-8.8-3.461-2.84-.241-5.782.458-8.722.967-1.801.312-3.89.194-5.497-.176-.366-.085-.621.3-.414.62C1.376 3.619 2.421 6.001 3.92 7.851",
  fill: "#49658A",
  mask: "url(#b)"
})), React.createElement("path", {
  d: "M27.932 36.047c0-5.436 4.422-9.857 9.857-9.857a9.8 9.8 0 0 1 3.27.558c.914-1.766 1.495-3.714 1.77-5.738.41-3.045-.036-6.378.06-9.448.013-.394-.33-.632-.643-.544a.489.489 0 0 0-.23.135c-2.73 2.657-6.364 3.912-9.867 5.347-1.71.703-3.39 1.448-4.912 2.42-.33.21-.658.435-.973.671a13.158 13.158 0 0 0-2.564 2.486 10.634 10.634 0 0 0-1.605 2.941c-.6 1.654-.842 3.43-.945 5.236-.19 3.276.23 6.583 1.21 9.715.399 1.27.795 2.595 1.463 3.756.15.255.316.587.588.731.355.19.778-.226.555-.586-1.588-2.534-1.993-5.904-1.616-8.86.433-3.396 2.41-5.9 5.14-7.856a40.479 40.479 0 0 1 2.245-1.486.147.147 0 0 1 .05-.02c.166-.047.307.177.156.304-.862.725-1.717 1.45-2.513 2.2-3.898 3.67-4.331 9.784-2.618 9.302.14-.04.293-.123.458-.254a13.1 13.1 0 0 1 1.664-1.1v-.053",
  fill: "#49658A"
}), React.createElement("g", {
  transform: "translate(27.74 26.163)"
}, React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#c"
})), React.createElement("path", {
  d: "M10.048 17.857c-4.396 0-7.973-3.578-7.973-7.974 0-4.396 3.577-7.973 7.973-7.973 4.397 0 7.974 3.577 7.974 7.973s-3.577 7.974-7.974 7.974m0-17.83C4.614.026.191 4.446.191 9.882c0 5.435 4.423 9.857 9.857 9.857 5.436 0 9.858-4.422 9.858-9.857S15.484.026 10.048.026",
  fill: "#49658A",
  mask: "url(#d)"
})), React.createElement("path", {
  d: "M40.85 37.775l-2.12-2.118v-5.223a.943.943 0 0 0-1.883 0v5.613c0 .25.098.487.275.666l2.395 2.394a.936.936 0 0 0 .666.276.937.937 0 0 0 .666-.276.937.937 0 0 0 .276-.666.935.935 0 0 0-.276-.666",
  fill: "#49658A"
}), React.createElement("path", {
  d: "M27.5.635c-7.176 0-13.923 2.794-18.997 7.868S.635 20.324.635 27.5s2.794 13.922 7.868 18.997c5.074 5.074 11.821 7.868 18.997 7.868s13.923-2.794 18.997-7.868c5.074-5.075 7.868-11.821 7.868-18.997s-2.794-13.923-7.868-18.997S34.676.635 27.5.635M27.5 55c-7.345 0-14.251-2.86-19.445-8.055C2.86 41.751 0 34.845 0 27.5c0-7.346 2.86-14.251 8.055-19.445C13.249 2.86 20.155 0 27.5 0c7.345 0 14.251 2.86 19.445 8.055C52.14 13.249 55 20.155 55 27.5c0 7.346-2.86 14.251-8.055 19.445C41.751 52.14 34.845 55 27.5 55",
  fill: "#D1D1D1"
}));

const SvgIconResults2 = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 55,
  height: 55,
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIconResults2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-results-2.c93a798d.svg";
export { ForwardRef as ReactComponent };